// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WeCQ","right":"styles_right__1sbv7"};